import { render, staticRenderFns } from "./pedidos.vue?vue&type=template&id=adab86b2&scoped=true&"
import script from "./pedidos.vue?vue&type=script&lang=js&"
export * from "./pedidos.vue?vue&type=script&lang=js&"
import style0 from "./pedidos.vue?vue&type=style&index=0&id=adab86b2&prod&lang=css&"
import style1 from "./pedidos.vue?vue&type=style&index=1&id=adab86b2&prod&lang=scss&scoped=true&"
import style2 from "./pedidos.vue?vue&type=style&index=2&id=adab86b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adab86b2",
  null
  
)

export default component.exports